import dayjs from '../../utils/dayjs';
import { DataTable, EmptyState, Layout, Page, Text, Link, Card, Button } from '@shopify/polaris';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import emptyIMG from '../../media/images/empty.png';
import Pagination from '../../components/pagination';
import helpers from '../../helpers';

import SkeletonLoading from 'components/skeletonPageLoading';
import SimpleFilter from 'components/simpleFilter';
import { ___ } from 'languages/index';
import { TypedAddress_suggestion, useGetAddressSuggestions, useMutateDeleteAddressSuggestion } from 'queries/address_suggestion.query';
import { Helmet } from 'react-helmet-async';
import { DeleteIcon, PlusIcon } from '@shopify/polaris-icons';
import { useDeleteConfirm } from 'context/DeleteConfirmContext';
import AddressSuggesstionModal from './address_suggestion.modal';
const provinceData = require('config/provinceData.json');

export default function PickupTimeRule() {
  const [entities, setEntities] = useState<TypedAddress_suggestion[]>([]);
  const [totalItems, setTotalItems] = useState(0);

  const history = useNavigate();

  /**
   * If user apply filter, it will add to URL, then parse URL back to initial state
   */
  let { search } = useLocation();
  let StringQuery: any = helpers.ExtractUrl(search);

  const initialQuery = {
    query: '',
    page: 1,
    limit: 25,
    sort: 'createdAt:desc',
  };
  const [mainQuery, setMainQuery] = useState({
    ...initialQuery,
    ...StringQuery,
  });

  const { data, refetch: getEntities, isPending: loading } = useGetAddressSuggestions(mainQuery);

  useEffect(() => {
    if (data) {
      setEntities(data.body);
      setTotalItems(data.totalItems);
    }
  }, [data]);

  /**
   * Change page number
   */
  const onChangePagination = useCallback(
    (numPage: number, limit: number) => {
      setMainQuery({ ...mainQuery, page: numPage, limit: limit });
    },
    [mainQuery]
  );

  /**
   * Double request!
   */
  useEffect(() => {
    let buildURLSearch = helpers.buildEndUrl(mainQuery);
    if (search !== buildURLSearch) history('/address_suggestion' + buildURLSearch);
    getEntities();
  }, [mainQuery]);

  /**
   * I do not know ...
   * Bug: In React, do NOT remove this code
   */
  const filterCallback = useCallback((_value: any) => {
    if (_value === false) {
      return setMainQuery(initialQuery);
    } else {
      setMainQuery((oldValue) => {
        return { ...oldValue, ..._value };
      });
    }
  }, []);

  /** Xóa */
  const { mutateAsync: deleteFn } = useMutateDeleteAddressSuggestion();
  const { showDeleteConfirm } = useDeleteConfirm();
  const deleteCallback = useCallback(async (id) => {
    let askHim = await showDeleteConfirm('Bạn chắc chắn chứ?', 'Hành động này không thể hoàn tác, vùng này sẽ bị xóa khỏi cơ sở dữ liệu.');
    if (askHim) {
      try {
        await deleteFn(id);
      } catch (e) {}
    }
  }, []);

  /** Phục vụ cho cái modal */
  const [newModelactive, setNewModelactive] = useState(false);
  const toggleNewActive = useCallback(() => setNewModelactive((active) => !active), []);
  const currentAddressSuggestionID = useRef(null);

  const emptyData = (
    <EmptyState heading="Không có bản ghi!" image={emptyIMG}>
      <p>Oh, Không có gì ở đây. Hãy thử bỏ bộ lọc hoặc tạo mới.</p>
    </EmptyState>
  );

  const renderItem = (rule: TypedAddress_suggestion) => {
    const { id, address, journey_from_id, journey, createdAt } = rule;
    return [
      id,
      <Link
        key={id}
        onClick={() => {
          currentAddressSuggestionID.current = id;
          toggleNewActive();
        }}
      >
        <div style={{ minWidth: '150px' }}>{helpers.trimContentString(address)}</div>
      </Link>,
      provinceData[journey_from_id],
      journey?.journey_name || '-',
      createdAt ? dayjs(new Date(Number(createdAt))).format('HH:mm:ss DD-MM-YYYY') : '-',
      <Button icon={DeleteIcon} onClick={() => deleteCallback(id)} variant="monochromePlain"></Button>,
    ];
  };
  const PagesList =
    totalItems > 0 ? (
      <>
        <DataTable
          hoverable
          fixedFirstColumns={2}
          columnContentTypes={['text', 'text', 'text', 'text', 'text', 'text']}
          headings={['ID', 'Địa chỉ gợi ý', 'Điểm đón/trả', 'Hành trình', 'Tạo lúc', '-']}
          rows={entities?.map(renderItem)}
          hideScrollIndicator
          footerContent={___('Show page {display_page_number} of {total_record_number} results', {
            display_page_number: <Text as="strong">{mainQuery?.page || 1}</Text>,
            total_record_number: <Text as="strong">{totalItems}</Text>,
          })}
        />
      </>
    ) : (
      emptyData
    );

  const Actual_page = (
    <>
      <Helmet>
        <title>Danh sách điểm đón</title>
      </Helmet>
      <Page
        title="Danh sách điểm đón"
        subtitle="Các địa chỉ được gợi ý cho các hành trình, ví dụ như văn phòng vận chuyển, điểm trung chuyển..."
        primaryAction={{
          content: 'Thêm điểm đón',
          disabled: false,
          icon: PlusIcon,
          onAction: toggleNewActive,
        }}
      >
        <Layout>
          <Layout.Section>
            <Card padding="0">
              <SimpleFilter loading={loading} onCallback={filterCallback} options={[]} sortField={[]} />
              {PagesList}
            </Card>
            <br />
            {totalItems > mainQuery.limit ? (
              <Pagination TotalRecord={totalItems} activeCurrentPage={mainQuery.page} pageSize={mainQuery.limit} onChange={onChangePagination} />
            ) : null}
          </Layout.Section>
        </Layout>
      </Page>

      {
        <AddressSuggesstionModal
          show={newModelactive}
          currentAddressSuggestionID={currentAddressSuggestionID.current}
          onClose={() => {
            currentAddressSuggestionID.current = null;
            setNewModelactive(false);
          }}
        />
      }
    </>
  );

  return <>{entities === null ? <SkeletonLoading /> : Actual_page}</>;
}

